import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Card, CardBody } from 'reactstrap'
import { TitlePage } from 'components/atoms'
import { CmsLuxurySectionEditForm } from 'domains/cms-luxury-section/organisms'
import CmsLuxurySectionsApiV2 from 'api/v2/admins/cms/luxury/cms-luxury-sections-api-v2.js'
import CmsLuxurySectionService from 'domains/cms-luxury-section/services/cms-luxury-section-service'
import { ALERT_TYPES } from 'constants/alert-constants'
import PropTypes from 'prop-types'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CmsLuxurySectionEditPage = ({ pageUtils }) => {

  const { id }                          = useParams()
  const [ section, setSection ]         = useState({})
  const [ image, setImage ]             = useState(new Blob())
  const [ mobileImage, setMobileImage ] = useState(new Blob())
  const [ isLoading, setIsLoading ]     = useState(true)

  useEffect(() => {
    CmsLuxurySectionsApiV2.show(id)
      .then((response) => {
        const data = response.data.section
        setSection(data)
        setIsLoading(false)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ id, pageUtils ])

  const handleSubmitForm = async (values) => {

    const imagePayload       = CmsLuxurySectionService.prepImage(image)
    const mobileImagePayload = CmsLuxurySectionService.prepImage(mobileImage)
    const captionTextPayload = CmsLuxurySectionService.prepText(values.caption_text)
    const headerTextPayload  = CmsLuxurySectionService.prepText(values.header_text)
    const titleTextPayload   = CmsLuxurySectionService.prepText(values.title_text)

    const params = {
      'is_active'    : values.is_active,
      'name'         : values.name,
      'image'        : imagePayload,
      'mobile_image' : mobileImagePayload,
      'url'          : values.url,
      'alt_text'     : values.alt_text,
      'caption_text' : captionTextPayload,
      'header_text'  : headerTextPayload,
      'order'        : values.order,
      'seo_title'    : values.seo_title,
      'title_text'   : titleTextPayload
    }

    const payload = CmsLuxurySectionService.toFormData(params)

    await CmsLuxurySectionsApiV2.update(
      id,
      payload
    )
      .then(() => {
        pageUtils.setAlertMsg('Sucessfully update luxury section!', ALERT_TYPES.SUCCESS)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  return (
    <>
      <TitlePage mainTitle='Cms Luxury Section Edit Page' />
      <Card>
        <CardBody>
          <CmsLuxurySectionEditForm
            isLoading={ isLoading }
            section={ section }
            image={ image }
            mobileImage={ mobileImage }
            setImage={ setImage }
            setMobileImage={ setMobileImage }
            handleSubmitForm={ handleSubmitForm }
          />
        </CardBody>
      </Card>
    </>
  )
}

CmsLuxurySectionEditPage.propTypes    = propTypes
CmsLuxurySectionEditPage.defaultProps = defaultProps

export default CmsLuxurySectionEditPage
